import apiClient from './apiClient';
import { API_ENDPOINTS } from './endpoints';

/**
 * Partner Service
 * Workshop partner review: profile, documents, change requests, history.
 * Every method resolves with the raw body { IsSuccess, Data, Message }.
 */
const post = async (url, body) => (await apiClient.post(url, body)).data;

const partnerService = {
  getProfile: (venderId) => post(API_ENDPOINTS.PARTNERS.PROFILE, { venderId }),
  getHistory: (venderId) => post(API_ENDPOINTS.PARTNERS.HISTORY, { venderId }),
  getChangeRequests: (status = 'pending') => post(API_ENDPOINTS.PARTNERS.CHANGE_REQUESTS, { status }),
  reviewDocument: (payload) => post(API_ENDPOINTS.PARTNERS.REVIEW_DOCUMENT, payload),
  getLastOtps: () => post(API_ENDPOINTS.PARTNERS.LAST_OTPS, {}),
  revealOtp: (payload) => post(API_ENDPOINTS.PARTNERS.REVEAL_OTP, payload),
  reject: (payload) => post(API_ENDPOINTS.PARTNERS.REJECT, payload),
  reviewChange: (payload) => post(API_ENDPOINTS.PARTNERS.REVIEW_CHANGE, payload),
};

export default partnerService;
